/*
 * Kalmix custom code
 * File: assets/kmx-home-base.js
 * Version: 1009.1
 * History:
 * - 1009.1 Copy entrance and act entry no longer depend on fixed visibility-ratio
 *   steps: on short phone screens a tall act (02 is ~1240px at 375×667) could never
 *   reach the first step, so its heading, lead and buttons stayed transparent. Both
 *   are now checked on scroll / resize from the visible height: entry when it
 *   reaches 55% of the act or half the screen; copy when it reaches 85% of
 *   min(act height, screen height), or once the act's top has passed the top of the
 *   screen. Keyboard: left / right arrows inside a tab list (02 SCOUT / SCOUT PRO,
 *   04 scenes) move between tabs (Home / End jump to the ends); while a tab has
 *   focus the act-paging keys are left to the browser, so the page no longer jumps
 *   to the next act.
 * - 1008.3 The copy entrance now waits until the act has settled in view (85% of the
 *   act, or 85% of the screen for tall acts on phones) and marks it with is-shown,
 *   so bottom-aligned copy no longer animates while still below the fold.
 * - 1008.2 Copy entrance: adds html.kmx-anim so acts 02–06 fade their eyebrow,
 *   heading, lead and buttons up in sequence on first entry (CSS; the Hero shows at
 *   once). Keyboard paging on desktop: PageDown / PageUp / arrows / Space move one
 *   act (ignored in form fields and with modifier keys; past the last act the page
 *   scrolls on to the footer). The pager bar shows the current act's progress when
 *   the act reports it through KMX.progress(section, 0–1).
 * - 1008.1 Adds the right-hand act navigation (ported from prototype v4, refined):
 *   built from the acts on the page and their corner tags (01 / SIGNAL …), so it
 *   follows any change in acts. The current act is marked by a short bar that
 *   slides between the dots; names appear on hover / keyboard focus; click scrolls
 *   to the act (instant with reduced motion); colours follow the act's dark/light
 *   tone; the last act stays marked over the footer. Hidden at 860px and below.
 * - 1005.2 Measures the header content edges (desktop: logo left / icons right;
 *   mobile: header padding) into --kmx-edge-l / --kmx-edge-r so every act's
 *   content stays inside the theme page width.
 * - 1005.1 Initial delivery. Adds body.kmx-home, swaps the header PNG logo for the
 *   vector wordmark, measures header height (--kmx-hdr-h, --kmx-top0), enables
 *   desktop snap, switches header dark/light by data-hdr, exposes window.KMX
 *   enter/visibility callbacks for the act scripts. Does not modify header.liquid.
 */
(function () {
  if (window.KMX) return;
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var enterCbs = new Map();
  var visCbs = new Map();
  var visible = new WeakMap();

  var KMX = window.KMX = {
    reduce: reduce,
    isVisible: function (el) { return visible.get(el) === true; },
    onEnter: function (el, cb) {
      (enterCbs.get(el) || enterCbs.set(el, []).get(el)).push(cb);
      if (el.classList.contains('is-in')) cb(); // 注册晚于进入时，立即补触发
    },
    onVisible: function (el, cb) {
      (visCbs.get(el) || visCbs.set(el, []).get(el)).push(cb);
      if (visible.has(el)) cb(visible.get(el));
    },
    mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
    progress: function (el, p) { progress.set(el, p); if (KMX._pg) KMX._pg(); }
  };
  var progress = new WeakMap();

  function init() {
    var acts = Array.prototype.slice.call(document.querySelectorAll('.kmx-act'));
    if (!acts.length) return;
    document.body.classList.add('kmx-home');
    root.classList.add('kmx-snap');
    if (!reduce && window.IntersectionObserver) root.classList.add('kmx-anim');

    /* ---- Logo：用矢量字标替换主题 PNG（模板由 Hero section 输出） ---- */
    var tpl = document.getElementById('kmx-wordmark-tpl');
    var logoLink = document.querySelector('.section-header .header__heading-link');
    if (tpl && logoLink && !logoLink.querySelector('.kmx-wordmark')) {
      var png = logoLink.querySelector('.header__heading-logo');
      var w = png ? Math.round(png.getBoundingClientRect().width) : 0;
      if (w > 0) logoLink.style.setProperty('--kmx-logo-w', w + 'px');
      logoLink.appendChild(tpl.content.cloneNode(true));
      logoLink.classList.add('kmx-logo-swapped');
    }

    /* ---- Header 测量 ---- */
    var hs = document.querySelector('.section-header');
    var hw = document.querySelector('.section-header .header-wrapper');
    function measure() {
      if (!hs) return;
      var h = hs.offsetHeight;
      var top0 = hs.getBoundingClientRect().bottom + window.scrollY;
      if (window.scrollY > 0) {
        // 已经滚动时，Header 吸顶，用公告条高度 + Header 高度
        var ann = document.querySelector('.announcement-bar-section');
        top0 = (ann ? ann.offsetHeight : 0) + h;
      }
      document.body.style.setProperty('--kmx-hdr-h', h + 'px');
      document.body.style.setProperty('--kmx-top0', top0 + 'px');
    }
    /* ---- 内容边线：与 Header 对齐（桌面以 Logo 左边、图标右边为准），不超出主题页宽 ---- */
    function measureEdges() {
      var hdr = document.querySelector('.section-header .header');
      if (!hdr) return;
      var vw = document.documentElement.clientWidth;
      var r = hdr.getBoundingClientRect(), cs = getComputedStyle(hdr);
      var l = r.left + parseFloat(cs.paddingLeft), rr = vw - (r.right - parseFloat(cs.paddingRight));
      if (window.innerWidth >= 990) {
        var logo = document.querySelector('.section-header .kmx-wordmark') || document.querySelector('.section-header .header__heading-logo');
        var icons = document.querySelector('.section-header .header__icons');
        if (logo) { var lr = logo.getBoundingClientRect(); if (lr.width) l = lr.left; }
        if (icons) { var ir = icons.getBoundingClientRect(); if (ir.width) rr = vw - ir.right; }
      }
      document.body.style.setProperty('--kmx-edge-l', Math.max(0, Math.round(l)) + 'px');
      document.body.style.setProperty('--kmx-edge-r', Math.max(0, Math.round(rr)) + 'px');
    }

    measure();
    measureEdges();
    if (window.ResizeObserver && hs) new ResizeObserver(function () { measure(); measureEdges(); }).observe(hs);
    window.addEventListener('resize', measureEdges);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureEdges);
    window.addEventListener('resize', measure);

    /* ---- Header 深浅 ---- */
    var footer = document.querySelector('.footer, footer');
    function syncHeader() {
      if (!hw) return;
      var y = hw.getBoundingClientRect().bottom + 2;
      var mode = null;
      for (var i = 0; i < acts.length; i++) {
        var b = acts[i].getBoundingClientRect();
        if (b.top <= y && b.bottom > y) { mode = acts[i].getAttribute('data-hdr') || 'dark'; break; }
      }
      if (!mode && footer) { var fb = footer.getBoundingClientRect(); if (fb.top <= y) mode = 'dark'; }
      if (!mode) mode = 'light';
      hw.classList.toggle('kmx-hdr--dark', mode === 'dark');
      hw.classList.toggle('kmx-hdr--light', mode === 'light');
    }
    window.addEventListener('scroll', syncHeader, { passive: true });
    window.addEventListener('resize', syncHeader);
    syncHeader();

    /* ---- 右侧幕导航：按页面上的幕自动生成，当前幕用滑动短条标出 ---- */
    function buildPager() {
      if (document.querySelector('.kmx-pager')) return;
      var nav = document.createElement('nav');
      nav.className = 'kmx-pager';
      nav.setAttribute('aria-label', 'Homepage sections');
      var bar = document.createElement('span');
      bar.className = 'kmx-pager__bar';
      bar.setAttribute('aria-hidden', 'true');
      nav.appendChild(bar);
      var items = acts.map(function (a, i) {
        if (!a.id) a.id = 'kmx-act-' + (i + 1);
        var tag = a.querySelector('.kmx-tag');
        var label = tag ? tag.textContent.replace(/\s*\/\s*/, ' ').replace(/\s+/g, ' ').trim() : ('0' + (i + 1)).slice(-2);
        var head = a.querySelector('h1, h2');
        var link = document.createElement('a');
        link.className = 'kmx-pager__item';
        link.href = '#' + a.id;
        link.setAttribute('aria-label', label + (head ? ' — ' + head.textContent.replace(/\s+/g, ' ').trim() : ''));
        link.innerHTML = '<span class="kmx-pager__label">' + label + '</span><i class="kmx-pager__dot" aria-hidden="true"></i>';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          a.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
        nav.appendChild(link);
        return link;
      });
      document.body.appendChild(nav);

      var cur = -1;
      function sync() {
        var mid = window.innerHeight / 2, idx = -1;
        for (var i = 0; i < acts.length; i++) {
          var b = acts[i].getBoundingClientRect();
          if (b.top <= mid && b.bottom > mid) { idx = i; break; }
        }
        if (idx < 0) idx = acts[acts.length - 1].getBoundingClientRect().bottom <= mid ? acts.length - 1 : 0; // Footer 区域仍标最后一幕
        if (idx === cur) return;
        cur = idx;
        items.forEach(function (it, j) {
          it.classList.toggle('is-on', j === idx);
          if (j === idx) it.setAttribute('aria-current', 'true'); else it.removeAttribute('aria-current');
        });
        bar.style.transform = 'translateY(' + items[idx].offsetTop + 'px)';
        nav.setAttribute('data-tone', acts[idx].getAttribute('data-hdr') === 'light' ? 'light' : 'dark');
      }
      window.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', function () { cur = -1; sync(); });
      sync();
      // 当前幕上报的进度（0–1），画进导航短条；未上报的幕显示满条
      var lastP = -1;
      KMX._pg = function () {
        if (cur < 0) return;
        var p = progress.has(acts[cur]) ? progress.get(acts[cur]) : 1;
        p = Math.round(Math.max(0, Math.min(1, p)) * 50) / 50;
        if (p !== lastP) { lastP = p; bar.style.setProperty('--pg-p', p); }
      };
      window.addEventListener('scroll', function () { lastP = -1; KMX._pg(); }, { passive: true });

      // 键盘按幕翻页（桌面）
      var lock = false;
      window.addEventListener('keydown', function (e) {
        if (window.innerWidth <= 860 || e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return;
        var tg = e.target, tn = tg && tg.tagName;
        if (tn === 'INPUT' || tn === 'TEXTAREA' || tn === 'SELECT' || (tg && tg.isContentEditable)) return;
        if (tg && tg.closest && tg.closest('[role="tablist"]')) return; // 焦点在页签上：方向键交给页签切换
        var dir = 0, k = e.key;
        if (k === 'PageDown' || k === 'ArrowDown' || (k === ' ' && !e.shiftKey)) dir = 1;
        else if (k === 'PageUp' || k === 'ArrowUp' || (k === ' ' && e.shiftKey)) dir = -1;
        if (!dir || cur < 0) return;
        var next = cur + dir;
        if (next >= acts.length || next < 0) return; // 最后一幕之后交给浏览器，继续滚到 Footer
        if (k === ' ' && tn === 'BUTTON') return;
        e.preventDefault(); if (lock) return; lock = true;
        acts[next].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        setTimeout(function () { lock = false; }, 650);
      });
      requestAnimationFrame(function () { nav.classList.add('is-ready'); });
    }
    buildPager();

    /* ---- 可见 / 进入 ---- */
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible.set(e.target, e.isIntersecting);
        (visCbs.get(e.target) || []).forEach(function (cb) { cb(e.isIntersecting); });
      });
    }, { threshold: 0 });
    acts.forEach(function (a) { vio.observe(a); });

    // 进入（启动本幕动画）与文字进场（等本幕基本停稳再播），都只触发一次。
    // 按可见高度判断，滚动 / 尺寸变化时检查：手机上比屏幕高很多的幕也能触发。
    var pending = acts.slice(), ticking = false;
    function check() {
      ticking = false;
      var vh = window.innerHeight;
      pending = pending.filter(function (a) {
        var r = a.getBoundingClientRect();
        if (!r.height) return true;
        var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        if (!a.classList.contains('is-in') && (seen >= r.height * .55 || seen >= vh * .5)) {
          a.classList.add('is-in');
          (enterCbs.get(a) || []).forEach(function (cb) { cb(); });
        }
        if (seen >= Math.min(r.height, vh) * .85 || r.top <= 0) { a.classList.add('is-shown'); return false; }
        return true;
      });
      if (!pending.length) {
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', schedule);
      }
    }
    function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    check();

    // 页签（02 SCOUT / SCOUT PRO、04 场景）：左右方向键切换，Home / End 到两端；上下键保留浏览器默认滚动
    document.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      var tab = e.target && e.target.closest && e.target.closest('[role="tab"]');
      var list = tab && tab.closest('[role="tablist"]');
      if (!list || !list.closest('.kmx-act')) return;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      var i = tabs.indexOf(tab), n = tabs.length, j = -1;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault();
      tabs[j].focus();
      tabs[j].click();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
